import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AuthImg } from "@/components/studio/AuthImg";

const LABELS = ["Cover", "Contents", "Chapter I"];

export const PdfPreview = ({ p, theme }) => {
  const files = p.files || {};
  const [open, setOpen] = useState(0);
  const n = files.preview_paths?.length || 0;
  if (!n) {
    return (
      <div className="flex gap-2" data-testid="pdf-preview-empty">
        {LABELS.map((l) => <div key={l} className="w-[58px] aspect-[210/297] border border-dashed border-[#2A2325]/20" />)}
        <p className="text-xs text-[#5C5255] self-center max-w-[150px] ml-1">{p.files?.pdf_path ? "Rebuild the files to preview the first pages" : "Build the files to preview the first pages"}</p>
      </div>
    );
  }
  return (
    <>
      <div className="flex items-end gap-2" data-testid="pdf-preview">
        {Array.from({ length: n }, (_, i) => (
          <button key={i} onClick={() => setOpen(i + 1)} className="group text-left" data-testid={`pdf-preview-thumb-${i + 1}`} aria-label={`Preview ${LABELS[i]}`}>
            <AuthImg path={`/products/${p.id}/pdf-preview/${i + 1}.png`} version={files.generated_at} alt={LABELS[i]} className="w-[58px] aspect-[210/297] object-cover border border-[#2A2325]/15 shadow-sm transition-transform group-hover:-translate-y-0.5" />
            <div className="text-[9px] tracking-[0.18em] uppercase text-[#5C5255] mt-1">{i + 1} · {LABELS[i]}</div>
          </button>
        ))}
        {files.page_count && (
          <div className="text-xs text-[#5C5255] ml-1 leading-tight" data-testid="pdf-page-count">
            <span className="font-playfair text-2xl block" style={{ color: theme.dark }}>{files.page_count}</span>pages · A4
          </div>
        )}
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(0)}>
        <DialogContent className="bg-[#FFFDF9] rounded-none sm:max-w-xl" data-testid="pdf-preview-dialog">
          <DialogHeader><DialogTitle className="font-playfair text-2xl">Page {open} · {LABELS[open - 1]}</DialogTitle></DialogHeader>
          {open > 0 && <AuthImg path={`/products/${p.id}/pdf-preview/${open}.png`} version={files.generated_at} alt="" className="w-full aspect-[210/297] object-contain border border-[#2A2325]/10" testId="pdf-preview-large" />}
          <div className="flex justify-between text-sm">
            <button disabled={open <= 1} onClick={() => setOpen(open - 1)} className="disabled:opacity-30 hover:underline" data-testid="pdf-preview-prev">← Previous</button>
            <button disabled={open >= n} onClick={() => setOpen(open + 1)} className="disabled:opacity-30 hover:underline" data-testid="pdf-preview-next">Next →</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
